import { useTranslation } from 'react-i18next';

export function RouteErrorScreen() {
  const { t, i18n } = useTranslation();
  return <main dir={i18n.language.startsWith('ar') ? 'rtl' : 'ltr'} className="flex min-h-screen items-center justify-center bg-background p-6">
    <section role="alert" className="w-full max-w-md rounded-xl border bg-card p-6 text-center shadow-sm">
      <h1 className="text-xl font-semibold">{t('common.errorLoadingData')}</h1>
      <p className="mt-3 text-muted-foreground">{t('common.errorLoadingDescription')}</p>
      <button type="button" onClick={() => window.location.reload()} className="mt-5 rounded-lg bg-primary px-5 py-3 text-primary-foreground">{t('common.retry')}</button>
    </section>
  </main>;
}
